import { z } from 'zod';

export const uuid = z.uuid();
export const isoDate = z.string();

/** India-only for now. Accepts 9876543210, 09876543210, 919876543210, +91 98765 43210. Returns E.164. */
export function normalizeIndianPhone(input: string): string | null {
  const digits = input.replace(/[\s\-().]/g, '');
  const m = /^(?:\+?91|0)?([6-9]\d{9})$/.exec(digits);
  return m ? `+91${m[1]}` : null;
}

export const phone = z
  .string()
  .transform((v, ctx) => {
    const n = normalizeIndianPhone(v);
    if (!n) {
      ctx.issues.push({ code: 'custom', message: 'Enter a valid 10-digit Indian mobile number', input: v });
      return z.NEVER;
    }
    return n;
  });

export const memberRole = z.enum(['admin', 'owner', 'tenant', 'family', 'guard', 'staff']);
export type MemberRole = z.infer<typeof memberRole>;

export const paging = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(30),
  /** Opaque cursor returned by the previous page (created_at|id). */
  cursor: z.string().max(200).optional(),
});

export const problem = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
    requestId: z.string().optional(),
  }),
});
export type Problem = z.infer<typeof problem>;

export const okResponse = z.object({ ok: z.literal(true) });

export const idParam = z.object({ id: uuid });

export const trimmed = (min: number, max: number) => z.string().trim().min(min).max(max);
